import React, {Fragment} from 'react';
import PartnerTablePartnerTypeRow from "./PartnerTablePartnerTypeRow";
import PartnerTablePartnerRow from "./PartnerTablePartnerRow";

export default function PartnersTableBody({columns = [], tableData=[], toggleRowOpen, afterUpdateCallback}) {
    return (
        <tbody className="statistic_body">
        {
            tableData.map(row =>
                <Fragment key={row.partnerType}>
                    <PartnerTablePartnerTypeRow key={row.partnerType} columns={columns} rowData={row} toggleRowOpen={toggleRowOpen}/>
                    {
                        row.partners && row.partners.map(partner =>
                            <PartnerTablePartnerRow key={partner.id} columns={columns} rowData={partner} afterUpdateCallback={afterUpdateCallback}/>
                            )
                    }
                </Fragment>
            )
        }
        </tbody>
    );
}